export default "__VITE_ASSET__DlhTXi77__"